// extracted by mini-css-extract-plugin
export var alignCenter = "_7j-d";
export var bannerShown = "_7j-6";
export var buttonContent = "_7j-0";
export var cardList = "_7j-1";
export var centerContent = "_7j-2";
export var chevron = "_7j-3";
export var closePanelButton = "_7j-k";
export var conversationContextContainer = "_7j-l";
export var conversationDetailContainer = "_7j-4";
export var detailWrapper = "_7j-7";
export var dropdownButton = "_7j-e";
export var dropdownTitle = "_7j-9";
export var fullHeight = "_7j-5";
export var hidden = "_7j-a";
export var icon = "_7j-b";
export var mergeSuggestionWrapper = "_7j-m";
export var panel = "_7j-i";
export var portalButtonsWrapper = "_7j-c";
export var right = "_7j-j";
export var tableSummaryContainer = "_7j-8";
export var tableSummaryHeader = "_7j-g";
export var threeDotsButton = "_7j-f";
export var wide = "_7j-h";